import $foreign from "./foreign.cjs";
var documentBody = $foreign.documentBody;
export { documentBody };
